import client from '../../base-api';

const serviceURL = '/dashboard/assistant-vq';

const dashboardAssistantVQService = {

    getInfoData() {
        return client.get(`${serviceURL}`);
    },
}

export default dashboardAssistantVQService;